export default __webpack_public_path__ + "afd5f94e9fc85dc6d37c71e942bb6029.svg";